import { render, staticRenderFns } from "./Finalizado.vue?vue&type=template&id=7952846e&scoped=true&"
import script from "./Finalizado.vue?vue&type=script&lang=js&"
export * from "./Finalizado.vue?vue&type=script&lang=js&"
import style0 from "./Finalizado.vue?vue&type=style&index=0&id=7952846e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7952846e",
  null
  
)

export default component.exports